import { DateTime } from "@/data/util/DateTime";

import { i18n } from "@/portal/Trans";

export class PortalDateTime {
    static dayFormat(days: number, short?: boolean): string {
        if (short !== undefined && short === true) return days + "T";

        return i18n("general.timeFormat.daysWithCount", { count: days });
    }

    static hourFormat(hours: number, short?: boolean): string {
        if (short !== undefined && short === true) return hours + "h";

        return i18n("general.timeFormat.hoursWithCount", { count: hours });
    }

    static minuteFormat(minutes: number, short?: boolean): string {
        if (short !== undefined && short === true) return minutes + "m";

        return i18n("general.timeFormat.minutesWithCount", { count: minutes });
    }

    static secondFormat(seconds: number, short?: boolean): string {
        if (short !== undefined && short === true) return seconds + "s";

        return i18n("general.timeFormat.secondsWithCount", { count: seconds });
    }

    static toRelativeString(date: Date, short?: boolean): string {
        const commingSeconds = (date.getTime() - new Date().getTime()) / 1000;

        if (commingSeconds > 86400)
            return i18n("general.timeFormat.inCount", {
                count: this.dayFormat(Math.round(commingSeconds / 86400), short),
            });
        else if (commingSeconds > 3600)
            return i18n("general.timeFormat.inCount", {
                count: this.hourFormat(Math.round(commingSeconds / 3600), short),
            });
        else if (commingSeconds > 60)
            return i18n("general.timeFormat.inCount", {
                count: this.minuteFormat(Math.round(commingSeconds / 60), short),
            });
        else if (commingSeconds >= 0)
            return i18n("general.timeFormat.inCount", {
                count: this.secondFormat(Math.round(commingSeconds), short),
            });

        if (commingSeconds > -60)
            return i18n("general.timeFormat.agoCount", {
                count: this.secondFormat(Math.round(commingSeconds * -1), short),
            });
        else if (commingSeconds > -3600)
            return i18n("general.timeFormat.agoCount", {
                count: this.minuteFormat(Math.round(commingSeconds / -60), short),
            });
        else if (commingSeconds > -86400)
            return i18n("general.timeFormat.agoCount", {
                count: this.hourFormat(Math.round(commingSeconds / -3600), short),
            });
        else if (commingSeconds > -2592000)
            return i18n("general.timeFormat.agoCount", {
                count: this.dayFormat(Math.round(commingSeconds / -86400), short),
            });

        return `${DateTime.toDateString(date)}`;
    }

    static timeFromMinutes(minutes: number): string {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;

        const hoursText =
            hours === 1
                ? i18n("general.timeFormat.hoursWithCount_one", { count: hours })
                : i18n("general.timeFormat.hoursWithCount_other", { count: hours });

        const minutesText =
            remainingMinutes === 1
                ? i18n("general.timeFormat.minutesWithCount_one", { count: remainingMinutes })
                : i18n("general.timeFormat.minutesWithCount_other", { count: remainingMinutes });

        return `${hoursText} ${minutesText}`.trim();
    }
}
